import Axios from "axios";

import { SET_VAT_REGISTER_LIST, UNSET_VAT_REGISTER_LIST } from "@/store/mutation-types";


import {
  getVatRegister as getVatRegisterApi,
  vatPayout as vatPayoutApi
} from "@/store/api";

const state = {
  getVatRegisterList: [],
};


const getters = {
  getVatRegisterList(state) {
    return state.getVatRegisterList;
  },
};


// Mutations
const mutations = {
  [SET_VAT_REGISTER_LIST](state, data) {
    state.getVatRegisterList = data;
  },
  [UNSET_VAT_REGISTER_LIST](state) {
    state.getVatRegisterList = [];
  },
};

// Actions
const actions = {
  /**
   * Get voucher list by type
   */
  getVatRegisterList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${getVatRegisterApi}`, { params: data })
        .then((response) => {
          commit(SET_VAT_REGISTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_VAT_REGISTER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  storeVatPayout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(vatPayoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

};


export default {
  state,
  getters,
  actions,
  mutations,
};